// 3rd-party libraries
import parse from "html-react-parser"

export default function TextWidget({ fieldId, field }) {
  return parse(field.htmlText)
}
